// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"267":"89cd5f52","613":"93d5fb4a","755":"6c17a125","856":"37927485"}[chunkId] + ".chunk.css";
};